import React from "react";
import PropTypes from "prop-types";
import "./_button.scss";

const Button = ({
  text,
  icon,
  href,
  mouseEnter,
  mouseLeave,
  click
}) => {
  const iconImage = icon ? <img src={icon} alt="Step" /> : null;

  return href
    ? <a
        onMouseEnter={mouseEnter}
        onMouseLeave={mouseLeave}
        href={href}
        className="wizard__button"
        target="_blank"
        rel="nofollow noreferrer">
          {iconImage}<span dangerouslySetInnerHTML={{__html: text}}></span>
      </a>
    : <button
        onClick={click}
        onMouseEnter={mouseEnter}
        onMouseLeave={mouseLeave}
        className="wizard__button">
          {iconImage}<span dangerouslySetInnerHTML={{__html: text}}></span>
      </button>
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string,
  image: PropTypes.string,
  href: PropTypes.string
};

export default Button;
